<template>
  <el-container>
    <el-header class="table-header">
      <el-button type="primary" class="btn" size="small" @click="submit">{{$t('common.Save')}}</el-button>
    </el-header>
    <el-main class="table-main">
      <el-form :model="form" label-width="80px" class="table-form" size="mini" ref="form" :rules="CommitForm">
        <el-row :gutter="20">
          <el-divider content-position="left">{{$t('base.info.role.RoleInformation')}}</el-divider>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.role.RoleCode')" prop="code">
              <el-input v-model="form.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.role.RoleName')" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Status')" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio :label="10">{{$t('common.Draft')}}</el-radio>
                <el-radio :label="40">{{$t('common.Disable')}}</el-radio>
                <el-radio :label="50">{{$t('common.Normal')}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('common.Remark')" prop="remark">
              <el-input v-model="form.remark" type="textarea"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('common.Type')" prop="type">
              <el-radio-group v-model="form.type">
                <el-radio :label="10">{{$t('base.info.role.SystemRetention')}}</el-radio>
                <el-radio :label="20">{{$t('base.info.role.Custom')}}</el-radio>
                <el-radio :label="50">{{$t('base.info.role.OnlineRegister')}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider content-position="left">{{$t('base.info.role.AuthorityInformation')}}</el-divider>
      <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" default-expand-all
        :tree-props="{children: 'children',hasChildren: 'hasChildren'}" border stripe>
        <el-table-column type="index" align="center">
        </el-table-column>
        <el-table-column prop="label" width="150" :label="$t('base.info.role.ModelName')">
        </el-table-column>
        <template v-for='(col,index) in fData'>
          <el-table-column align="center" width="150%">
            <template slot-scope="scope" slot="header">
              <el-checkbox :indeterminate="isIndeterminate[index]" v-model="selectAll[index]"
                           @change="( (val) => handleCheckAllChange(val,index))">{{col.name}}
              </el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-checkbox-group v-model="checks[index]"
                                 @change="((value) => handleCheckedCitiesChange(value,index))">
                <el-checkbox :label="scope.row.id" :key="scope.row.id">{{''}}</el-checkbox>
              </el-checkbox-group>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </el-main>
    <el-dialog :title="$t('base.info.role.ChooseSystem')" :visible.sync="dialogFormVisible" :before-close="handleClose" width="30%">
      <el-form :model="formDialog" ref="formDialog" size="mini" label-width="120px" :rules="rule">
        <el-row :gutter="20">
          <el-col :span="24">
        <el-form-item :label="$t('base.info.role.PleaseChooseSystem')" prop="systemId">
        <el-select v-model="formDialog.systemId">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="comfirm">{{$t('common.Ok')}}</el-button>
        <el-button size="mini" @click="cancel">{{$t('common.Cancel')}}</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<style>
  .btn {
    float: right;
    margin: 5px;
  }

  . row2 {
    padding-left: 10px;
  }
</style>

<script>

export default {
  data () {
    return {
      formDialog: {},
      form: {
        systemId: '',
        type: 10,
        status: 10
      },
      form1: {},
      tableData: [],
      fData: [],
      mData: [],
      selectAll: [],
      isIndeterminate: [],
      checks: [], // 所选择的所有复选框的数据
      checksData: [], // 封装的数据，包含checks,code,roleId,systemId
      temp: [], // 临时数组的作用
      totalData: { // 传给后台的数据
        form: {},
        checksData: []
      },
      id: [],
      options: [],
      CommitForm: {
        name: [{required: true, trigger: 'blur', message: '角色名称不能为空'}],
        code: [{required: true, trigger: 'blur', message: '角色编码不能为空'}],
        id: [{required: true, type: 'number', trigger: 'blur', message: '角色ID不能为空且必须为数字'}],
        remark: [{max: 90, message: '最多90个汉字'}]
      },
      rule: {
        systemId: [{required: true, trigger: 'change', message: '请选择系统类型'}]
      },
      dialogStatus: '',
      dialogFormVisible: false
    }
  },
  methods: {
    handleCheckAllChange (val, index) {
      if (val) {
        this.$set(this.checks, index, this.id)
      } else {
        this.$set(this.checks, index, [])
      }
      this.$set(this.isIndeterminate, index, false)
    },
    handleCheckedCitiesChange (value, index) {
      let checkedCount = value.length
      this.$set(this.selectAll, index, checkedCount === this.id.length)
      this.$set(this.isIndeterminate, index, checkedCount > 0 && checkedCount < this.id.length)
    },
    handleClose () {
      this.cancel()
    },
    handleInit () {
      this.$api.menuList.findMenuBySystemId(this.qs.stringify({systemId: this.form.systemId})).then((response) => {
        this.tableData = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    comfirm (data) {
      this.$refs['formDialog'].validate(valid => {
        if (valid) {
          this.form.systemId = this.formDialog.systemId
          this.dialogFormVisible = false
          this.handleInit()
          this.initTableHead()
        }
      })
    },
    initMenu () {
      this.$api.menuList.findMenuBySystemId(this.qs.stringify({systemId: this.form.systemId})).then((response) => {
        this.tableData = response.data.data
        // 将tree型菜单数据的id存入id数组
        for (let j = 0; j < this.tableData.length; j++) {
          if (this.tableData[j].children.length > 0) {
            this.loop(this.tableData[j]) // 递归方法
          } else {
            this.id.push(this.tableData[j].id)
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    initTableHead () {
      this.$api.functionList.functionfindBySystemId(this.qs.stringify({systemId: this.form.systemId})).then((response) => {
        this.fData = response.data.data
        // 初始化复选框表头数据
        for (let i = 0; i < this.fData.length; i++) {
          this.checks[i] = []
          this.isIndeterminate[i] = false
          this.selectAll[i] = false
          this.temp[i] = {code: this.fData[i].functId, col_index: i}
        }
        this.initMenu()
      }).catch((error) => {
        console.log(error)
      })
    },
    dataFormat () {
      // 初始化准备提交到后台的已勾选数据的格式
      for (let i = 0; i < this.id.length; i++) {
        this.mData.push({menuId: this.id[i], row_index: i})
        this.checksData.push({menuId: this.id[i], idList: [], functIdList: ''})
      }
      // checks保存所有菜单的id,check[0]为勾选框的第一列所勾选的菜单id
      let count = 0
      this.checks.forEach(item => {
        // 对第一列勾选框进行遍历
        for (let i = 0; i < item.length; i++) {
          // 通过菜单id查找checksData中对应的数据，如果找到了，那么就将对应的功能id  push进这条数据
          for (let j = 0; j < this.checksData.length; j++) {
            if (item[i] === this.checksData[j].menuId) {
              this.checksData[j].idList.push(this.temp[count].code)
              break
            }
          }
        }
        count++
      })
      // 对checksData保存的数据格式化成后台需要的数据
      let dataAuth = []
      this.checksData.forEach((item, index) => {
        if (item.idList.length !== 0) {
          dataAuth.push(item)
        }
      })
      dataAuth.forEach(item => {
        let temp = ''
        for (let i = 0; i < item.idList.length; i++) {
          temp = `${temp}${item.idList[i]};`
        }
        item.functIdList = temp
        this.$delete(item, 'idList')
      })
      this.checksData = dataAuth.slice(0)
    },
    // 提交权限表单
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.dataFormat()
          this.totalData.checksData = this.checksData
          this.totalData.form = this.form
          let param = {data: {authSaveReqs: this.totalData.checksData, roleInsertReq: this.totalData.form}}
          this.$api.roleList.roleInsert(param).then((response) => {
            if (response.data.status === 'Y') {
              this.$message({
                message: response.data.message,
                type: 'success'
              })
              this.$store.dispatch('initPermission')
              this.cancel()
            } else {
              this.$message({
                message: response.data.message,
                type: 'error'
              })
            }
          }).catch((error) => {
            console.log(error)
          })
        }
      })
    },
    initSystemId () {
      this.$api.systemList.systemSelect().then((response) => {
        let temp = response.data.data
        for (let i = 0; i < temp.length; i++) {
          this.options.push({value: temp[i].id, label: temp[i].name})
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    update (form) {
      this.$api.roleList.roleUpdate(this.qs.stringify({strRole: form})).then((response) => {
        if (response.data.status === 'Y') {
          this.$message({
            message: response.data.message,
            type: 'success'
          })
        } else {
          this.$message({
            message: response.data.message,
            type: 'error'
          })
        }
        this.cancel()
      }).catch((error) => {
        console.log(error)
      })
    },
    cancel () {
      this.$router.push({path: '/roleList'})
      let tabItem = this.$store.getters.rightNav
      this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router})
    },
    loop (item) {
      if (item.children.length > 0) {
        this.id.push(item.id)
        for (let i in item.children) {
          this.loop(item.children[i])
        }
      } else if (item.children.length === 0) {
        this.id.push(item.id)
      }
    }
  },
  created () {
    this.initSystemId()
    this.dialogFormVisible = true
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/syssetting/roleAdd.vue